// This file is AUTOGENERATED, do not edit it manually!!!

import { filters as filtersde } from './filtersResx.de';
import { filters as filtersen } from './filtersResx.en';
import { filters as filtersen_risk } from './filtersResx.en_risk';
import { filters as filterses } from './filtersResx.es';
import { filters as filtersfr } from './filtersResx.fr';
import { filters as filtersit } from './filtersResx.it';
import { filters as filtersnl } from './filtersResx.nl';
import { filters as filterspl } from './filtersResx.pl';
import { filters as filterspt } from './filtersResx.pt';
import { filters as filtersru } from './filtersResx.ru';
import { filters as filterssk } from './filtersResx.sk';
import { filters as filterssv } from './filtersResx.sv';
import { filters as filterstr } from './filtersResx.tr';

const langMap: { [k: string]: Partial<typeof filtersen> } = {
    de: filtersde,
    en: filtersen,
    en_risk: filtersen_risk,
    es: filterses,
    fr: filtersfr,
    it: filtersit,
    nl: filtersnl,
    pl: filterspl,
    pt: filterspt,
    ru: filtersru,
    sk: filterssk,
    sv: filterssv,
    tr: filterstr,
};

/* tslint:disable: max-line-length */
export const filtersResx = {
    get Activity_Text() {
        return langMap[ep.resxCulture].Activity_Text || langMap.en.Activity_Text;
    },
    get ActivityActualBilling() {
        return langMap[ep.resxCulture].ActivityActualBilling || langMap.en.ActivityActualBilling;
    },
    get ActivityActualCompletionDateCondition_Text() {
        return langMap[ep.resxCulture].ActivityActualCompletionDateCondition_Text || langMap.en.ActivityActualCompletionDateCondition_Text;
    },
    get ActivityActualCost() {
        return langMap[ep.resxCulture].ActivityActualCost || langMap.en.ActivityActualCost;
    },
    get ActivityActualGreaterThanEstimated_Text() {
        return langMap[ep.resxCulture].ActivityActualGreaterThanEstimated_Text || langMap.en.ActivityActualGreaterThanEstimated_Text;
    },
    get ActivityActualHours() {
        return langMap[ep.resxCulture].ActivityActualHours || langMap.en.ActivityActualHours;
    },
    get ActivityActualLaborBilling() {
        return langMap[ep.resxCulture].ActivityActualLaborBilling || langMap.en.ActivityActualLaborBilling;
    },
    get ActivityActualLaborCost() {
        return langMap[ep.resxCulture].ActivityActualLaborCost || langMap.en.ActivityActualLaborCost;
    },
    get ActivityBillableHours() {
        return langMap[ep.resxCulture].ActivityBillableHours || langMap.en.ActivityBillableHours;
    },
    get ActivityBilled() {
        return langMap[ep.resxCulture].ActivityBilled || langMap.en.ActivityBilled;
    },
    get ActivityBilledLabor() {
        return langMap[ep.resxCulture].ActivityBilledLabor || langMap.en.ActivityBilledLabor;
    },
    get ActivityBilledPercentage() {
        return langMap[ep.resxCulture].ActivityBilledPercentage || langMap.en.ActivityBilledPercentage;
    },
    get ActivityBudgetVariance() {
        return langMap[ep.resxCulture].ActivityBudgetVariance || langMap.en.ActivityBudgetVariance;
    },
    get ActivityCreationDateCondition_Text() {
        return langMap[ep.resxCulture].ActivityCreationDateCondition_Text || langMap.en.ActivityCreationDateCondition_Text;
    },
    get ActivityCreator_Text() {
        return langMap[ep.resxCulture].ActivityCreator_Text || langMap.en.ActivityCreator_Text;
    },
    get ActivityCreatorCondition_Empty_Text() {
        return langMap[ep.resxCulture].ActivityCreatorCondition_Empty_Text || langMap.en.ActivityCreatorCondition_Empty_Text;
    },
    get ActivityCreatorCondition_Text() {
        return langMap[ep.resxCulture].ActivityCreatorCondition_Text || langMap.en.ActivityCreatorCondition_Text;
    },
    get ActivityCustomFieldCondition_Text() {
        return langMap[ep.resxCulture].ActivityCustomFieldCondition_Text || langMap.en.ActivityCustomFieldCondition_Text;
    },
    get ActivityDuration() {
        return langMap[ep.resxCulture].ActivityDuration || langMap.en.ActivityDuration;
    },
    get ActivityEACBillableExpenses() {
        return langMap[ep.resxCulture].ActivityEACBillableExpenses || langMap.en.ActivityEACBillableExpenses;
    },
    get ActivityEACBilling() {
        return langMap[ep.resxCulture].ActivityEACBilling || langMap.en.ActivityEACBilling;
    },
    get ActivityEACCost() {
        return langMap[ep.resxCulture].ActivityEACCost || langMap.en.ActivityEACCost;
    },
    get ActivityEACExpenses() {
        return langMap[ep.resxCulture].ActivityEACExpenses || langMap.en.ActivityEACExpenses;
    },
    get ActivityEACLaborBilling() {
        return langMap[ep.resxCulture].ActivityEACLaborBilling || langMap.en.ActivityEACLaborBilling;
    },
    get ActivityEACLaborCost() {
        return langMap[ep.resxCulture].ActivityEACLaborCost || langMap.en.ActivityEACLaborCost;
    },
    get ActivityEACNonBillableExpenses() {
        return langMap[ep.resxCulture].ActivityEACNonBillableExpenses || langMap.en.ActivityEACNonBillableExpenses;
    },
    get ActivityEndDateCondition_Text() {
        return langMap[ep.resxCulture].ActivityEndDateCondition_Text || langMap.en.ActivityEndDateCondition_Text;
    },
    get ActivityEstimatedExpensesAmount() {
        return langMap[ep.resxCulture].ActivityEstimatedExpensesAmount || langMap.en.ActivityEstimatedExpensesAmount;
    },
    get ActivityEstimatedExpensesBillableAmount() {
        return langMap[ep.resxCulture].ActivityEstimatedExpensesBillableAmount || langMap.en.ActivityEstimatedExpensesBillableAmount;
    },
    get ActivityEstimatedExpensesNonBillableAmount() {
        return langMap[ep.resxCulture].ActivityEstimatedExpensesNonBillableAmount || langMap.en.ActivityEstimatedExpensesNonBillableAmount;
    },
    get ActivityEstimatedHours() {
        return langMap[ep.resxCulture].ActivityEstimatedHours || langMap.en.ActivityEstimatedHours;
    },
    get ActivityETCBilling() {
        return langMap[ep.resxCulture].ActivityETCBilling || langMap.en.ActivityETCBilling;
    },
    get ActivityETCCost() {
        return langMap[ep.resxCulture].ActivityETCCost || langMap.en.ActivityETCCost;
    },
    get ActivityETCLaborBilling() {
        return langMap[ep.resxCulture].ActivityETCLaborBilling || langMap.en.ActivityETCLaborBilling;
    },
    get ActivityETCLaborCost() {
        return langMap[ep.resxCulture].ActivityETCLaborCost || langMap.en.ActivityETCLaborCost;
    },
    get ActivityExpectedProfit() {
        return langMap[ep.resxCulture].ActivityExpectedProfit || langMap.en.ActivityExpectedProfit;
    },
    get ActivityExpectedProfitPercentage() {
        return langMap[ep.resxCulture].ActivityExpectedProfitPercentage || langMap.en.ActivityExpectedProfitPercentage;
    },
    get ActivityExpensesAmount() {
        return langMap[ep.resxCulture].ActivityExpensesAmount || langMap.en.ActivityExpensesAmount;
    },
    get ActivityExpensesBillableAmount() {
        return langMap[ep.resxCulture].ActivityExpensesBillableAmount || langMap.en.ActivityExpensesBillableAmount;
    },
    get ActivityExpensesBilledAmount() {
        return langMap[ep.resxCulture].ActivityExpensesBilledAmount || langMap.en.ActivityExpensesBilledAmount;
    },
    get ActivityExpensesNonBillableAmount() {
        return langMap[ep.resxCulture].ActivityExpensesNonBillableAmount || langMap.en.ActivityExpensesNonBillableAmount;
    },
    get ActivityHealthCondition_Text() {
        return langMap[ep.resxCulture].ActivityHealthCondition_Text || langMap.en.ActivityHealthCondition_Text;
    },
    get ActivityHealthTypes() {
        return langMap[ep.resxCulture].ActivityHealthTypes || langMap.en.ActivityHealthTypes;
    },
    get ActivityIsMilestone() {
        return langMap[ep.resxCulture].ActivityIsMilestone || langMap.en.ActivityIsMilestone;
    },
    get ActivityNonBillableHours() {
        return langMap[ep.resxCulture].ActivityNonBillableHours || langMap.en.ActivityNonBillableHours;
    },
    get ActivityProcessCondition_Text() {
        return langMap[ep.resxCulture].ActivityProcessCondition_Text || langMap.en.ActivityProcessCondition_Text;
    },
    get ActivityProfit() {
        return langMap[ep.resxCulture].ActivityProfit || langMap.en.ActivityProfit;
    },
    get ActivityProfitPercentage() {
        return langMap[ep.resxCulture].ActivityProfitPercentage || langMap.en.ActivityProfitPercentage;
    },
    get ActivityProgress_Text() {
        return langMap[ep.resxCulture].ActivityProgress_Text || langMap.en.ActivityProgress_Text;
    },
    get ActivityStartDateCondition_Text() {
        return langMap[ep.resxCulture].ActivityStartDateCondition_Text || langMap.en.ActivityStartDateCondition_Text;
    },
    get ActivityStatusCondition_Text() {
        return langMap[ep.resxCulture].ActivityStatusCondition_Text || langMap.en.ActivityStatusCondition_Text;
    },
    get ActivityTotalBudget() {
        return langMap[ep.resxCulture].ActivityTotalBudget || langMap.en.ActivityTotalBudget;
    },
    get ActivityTypeCondition_Text() {
        return langMap[ep.resxCulture].ActivityTypeCondition_Text || langMap.en.ActivityTypeCondition_Text;
    },
    get ActivityTypes_Issue() {
        return langMap[ep.resxCulture].ActivityTypes_Issue || langMap.en.ActivityTypes_Issue;
    },
    get ActivityTypes_Request() {
        return langMap[ep.resxCulture].ActivityTypes_Request || langMap.en.ActivityTypes_Request;
    },
    get ActivityTypes_Task() {
        return langMap[ep.resxCulture].ActivityTypes_Task || langMap.en.ActivityTypes_Task;
    },
    get ActivityTypesCondition_Text() {
        return langMap[ep.resxCulture].ActivityTypesCondition_Text || langMap.en.ActivityTypesCondition_Text;
    },
    get ActualCompletionDate_Text() {
        return langMap[ep.resxCulture].ActualCompletionDate_Text || langMap.en.ActualCompletionDate_Text;
    },
    get add_filters() {
        return langMap[ep.resxCulture].add_filters || langMap.en.add_filters;
    },
    get AdvancedFilterTooltipContent_Text() {
        return langMap[ep.resxCulture].AdvancedFilterTooltipContent_Text || langMap.en.AdvancedFilterTooltipContent_Text;
    },
    get AdvancedFilterTooltipTitle_Text() {
        return langMap[ep.resxCulture].AdvancedFilterTooltipTitle_Text || langMap.en.AdvancedFilterTooltipTitle_Text;
    },
    get AllActivities_Text() {
        return langMap[ep.resxCulture].AllActivities_Text || langMap.en.AllActivities_Text;
    },
    get Apply_Text() {
        return langMap[ep.resxCulture].Apply_Text || langMap.en.Apply_Text;
    },
    get AssigneeCondition_Text() {
        return langMap[ep.resxCulture].AssigneeCondition_Text || langMap.en.AssigneeCondition_Text;
    },
    get AssigneeOption_Text() {
        return langMap[ep.resxCulture].AssigneeOption_Text || langMap.en.AssigneeOption_Text;
    },
    get AssigneeTeamCondition_Entity() {
        return langMap[ep.resxCulture].AssigneeTeamCondition_Entity || langMap.en.AssigneeTeamCondition_Entity;
    },
    get AssigneeUserCondition_Empty_Text() {
        return langMap[ep.resxCulture].AssigneeUserCondition_Empty_Text || langMap.en.AssigneeUserCondition_Empty_Text;
    },
    get AssigneeUserCondition_Entity() {
        return langMap[ep.resxCulture].AssigneeUserCondition_Entity || langMap.en.AssigneeUserCondition_Entity;
    },
    get BoolCustomField_No_Text() {
        return langMap[ep.resxCulture].BoolCustomField_No_Text || langMap.en.BoolCustomField_No_Text;
    },
    get BoolCustomField_NotSelected_Text() {
        return langMap[ep.resxCulture].BoolCustomField_NotSelected_Text || langMap.en.BoolCustomField_NotSelected_Text;
    },
    get BoolCustomField_Yes_Text() {
        return langMap[ep.resxCulture].BoolCustomField_Yes_Text || langMap.en.BoolCustomField_Yes_Text;
    },
    get BudgetAndCosts_Filters_Group() {
        return langMap[ep.resxCulture].BudgetAndCosts_Filters_Group || langMap.en.BudgetAndCosts_Filters_Group;
    },
    get CategoriesCondition_Text() {
        return langMap[ep.resxCulture].CategoriesCondition_Text || langMap.en.CategoriesCondition_Text;
    },
    get CategoryCondition_Empty_Text() {
        return langMap[ep.resxCulture].CategoryCondition_Empty_Text || langMap.en.CategoryCondition_Empty_Text;
    },
    get CategoryCondition_Entity() {
        return langMap[ep.resxCulture].CategoryCondition_Entity || langMap.en.CategoryCondition_Entity;
    },
    get CategoryCondition_Text() {
        return langMap[ep.resxCulture].CategoryCondition_Text || langMap.en.CategoryCondition_Text;
    },
    get Clear_All_Text() {
        return langMap[ep.resxCulture].Clear_All_Text || langMap.en.Clear_All_Text;
    },
    get CompletedStatus_Text() {
        return langMap[ep.resxCulture].CompletedStatus_Text || langMap.en.CompletedStatus_Text;
    },
    get constraints_filters_group() {
        return langMap[ep.resxCulture].constraints_filters_group || langMap.en.constraints_filters_group;
    },
    get ContainMore_Text() {
        return langMap[ep.resxCulture].ContainMore_Text || langMap.en.ContainMore_Text;
    },
    get CreationDate_Text() {
        return langMap[ep.resxCulture].CreationDate_Text || langMap.en.CreationDate_Text;
    },
    get CustomerCondition_Empty_Text() {
        return langMap[ep.resxCulture].CustomerCondition_Empty_Text || langMap.en.CustomerCondition_Empty_Text;
    },
    get CustomerCondition_Entity() {
        return langMap[ep.resxCulture].CustomerCondition_Entity || langMap.en.CustomerCondition_Entity;
    },
    get CustomerCondition_Text() {
        return langMap[ep.resxCulture].CustomerCondition_Text || langMap.en.CustomerCondition_Text;
    },
    get CustomFieldsFilters_Group() {
        return langMap[ep.resxCulture].CustomFieldsFilters_Group || langMap.en.CustomFieldsFilters_Group;
    },
    get DraftCondition_Text() {
        return langMap[ep.resxCulture].DraftCondition_Text || langMap.en.DraftCondition_Text;
    },
    get DraftStatus_Text() {
        return langMap[ep.resxCulture].DraftStatus_Text || langMap.en.DraftStatus_Text;
    },
    get EndDate_Text() {
        return langMap[ep.resxCulture].EndDate_Text || langMap.en.EndDate_Text;
    },
    get FilterByKeyword_Text() {
        return langMap[ep.resxCulture].FilterByKeyword_Text || langMap.en.FilterByKeyword_Text;
    },
    get FilterByPeriod_Text() {
        return langMap[ep.resxCulture].FilterByPeriod_Text || langMap.en.FilterByPeriod_Text;
    },
    get FilterByTimeframe_Text() {
        return langMap[ep.resxCulture].FilterByTimeframe_Text || langMap.en.FilterByTimeframe_Text;
    },
    get FilterTabs_Tab1() {
        return langMap[ep.resxCulture].FilterTabs_Tab1 || langMap.en.FilterTabs_Tab1;
    },
    get FilterTabs_Tab2() {
        return langMap[ep.resxCulture].FilterTabs_Tab2 || langMap.en.FilterTabs_Tab2;
    },
    get FilterTabs_Tab3() {
        return langMap[ep.resxCulture].FilterTabs_Tab3 || langMap.en.FilterTabs_Tab3;
    },
    get FilterTabs_Tab4() {
        return langMap[ep.resxCulture].FilterTabs_Tab4 || langMap.en.FilterTabs_Tab4;
    },
    get FilterTabs_Tab5() {
        return langMap[ep.resxCulture].FilterTabs_Tab5 || langMap.en.FilterTabs_Tab5;
    },
    get Followed() {
        return langMap[ep.resxCulture].Followed || langMap.en.Followed;
    },
    get FollowedByMe_Text() {
        return langMap[ep.resxCulture].FollowedByMe_Text || langMap.en.FollowedByMe_Text;
    },
    get From_Text() {
        return langMap[ep.resxCulture].From_Text || langMap.en.From_Text;
    },
    get general() {
        return langMap[ep.resxCulture].general || langMap.en.general;
    },
    get HealthCondition_Text() {
        return langMap[ep.resxCulture].HealthCondition_Text || langMap.en.HealthCondition_Text;
    },
    get HealthItemType_Bad() {
        return langMap[ep.resxCulture].HealthItemType_Bad || langMap.en.HealthItemType_Bad;
    },
    get HealthItemType_Good() {
        return langMap[ep.resxCulture].HealthItemType_Good || langMap.en.HealthItemType_Good;
    },
    get HealthItemType_Medium() {
        return langMap[ep.resxCulture].HealthItemType_Medium || langMap.en.HealthItemType_Medium;
    },
    get HealthItemType_NotCalculated() {
        return langMap[ep.resxCulture].HealthItemType_NotCalculated || langMap.en.HealthItemType_NotCalculated;
    },
    get HealthTooltip_Text() {
        return langMap[ep.resxCulture].HealthTooltip_Text || langMap.en.HealthTooltip_Text;
    },
    get HealthTooltipLink_Text() {
        return langMap[ep.resxCulture].HealthTooltipLink_Text || langMap.en.HealthTooltipLink_Text;
    },
    get HoursCondition_Text() {
        return langMap[ep.resxCulture].HoursCondition_Text || langMap.en.HoursCondition_Text;
    },
    get HoursFilters_Group() {
        return langMap[ep.resxCulture].HoursFilters_Group || langMap.en.HoursFilters_Group;
    },
    get HoursLeft() {
        return langMap[ep.resxCulture].HoursLeft || langMap.en.HoursLeft;
    },
    get InProgressStatus_Text() {
        return langMap[ep.resxCulture].InProgressStatus_Text || langMap.en.InProgressStatus_Text;
    },
    get InThePast() {
        return langMap[ep.resxCulture].InThePast || langMap.en.InThePast;
    },
    get InvalidDate() {
        return langMap[ep.resxCulture].InvalidDate || langMap.en.InvalidDate;
    },
    get Issue_Text() {
        return langMap[ep.resxCulture].Issue_Text || langMap.en.Issue_Text;
    },
    get KeepTyping_Text() {
        return langMap[ep.resxCulture].KeepTyping_Text || langMap.en.KeepTyping_Text;
    },
    get ListCustomFieldCondition_Empty_Text() {
        return langMap[ep.resxCulture].ListCustomFieldCondition_Empty_Text || langMap.en.ListCustomFieldCondition_Empty_Text;
    },
    get ManualRange() {
        return langMap[ep.resxCulture].ManualRange || langMap.en.ManualRange;
    },
    get Me() {
        return langMap[ep.resxCulture].Me || langMap.en.Me;
    },
    get Menu_Dates() {
        return langMap[ep.resxCulture].Menu_Dates || langMap.en.Menu_Dates;
    },
    get Milestone_Text() {
        return langMap[ep.resxCulture].Milestone_Text || langMap.en.Milestone_Text;
    },
    get MoneyCondition_Text() {
        return langMap[ep.resxCulture].MoneyCondition_Text || langMap.en.MoneyCondition_Text;
    },
    get More_Text() {
        return langMap[ep.resxCulture].More_Text || langMap.en.More_Text;
    },
    get MultiSelectCustomFieldCondition_Empty_Text() {
        return langMap[ep.resxCulture].MultiSelectCustomFieldCondition_Empty_Text || langMap.en.MultiSelectCustomFieldCondition_Empty_Text;
    },
    get NextMonth() {
        return langMap[ep.resxCulture].NextMonth || langMap.en.NextMonth;
    },
    get NextWeek() {
        return langMap[ep.resxCulture].NextWeek || langMap.en.NextWeek;
    },
    get no_filters() {
        return langMap[ep.resxCulture].no_filters || langMap.en.no_filters;
    },
    get NoCategory() {
        return langMap[ep.resxCulture].NoCategory || langMap.en.NoCategory;
    },
    get NoMatch_Text() {
        return langMap[ep.resxCulture].NoMatch_Text || langMap.en.NoMatch_Text;
    },
    get OnHoldStatus_Text() {
        return langMap[ep.resxCulture].OnHoldStatus_Text || langMap.en.OnHoldStatus_Text;
    },
    get PeopleCondition_Text() {
        return langMap[ep.resxCulture].PeopleCondition_Text || langMap.en.PeopleCondition_Text;
    },
    get PinTooltip_Text() {
        return langMap[ep.resxCulture].PinTooltip_Text || langMap.en.PinTooltip_Text;
    },
    get Portfolio_Status_Text() {
        return langMap[ep.resxCulture].Portfolio_Status_Text || langMap.en.Portfolio_Status_Text;
    },
    get PortfolioCondition_Empty_Text() {
        return langMap[ep.resxCulture].PortfolioCondition_Empty_Text || langMap.en.PortfolioCondition_Empty_Text;
    },
    get PortfolioCondition_Entity() {
        return langMap[ep.resxCulture].PortfolioCondition_Entity || langMap.en.PortfolioCondition_Entity;
    },
    get PortfolioCondition_Text() {
        return langMap[ep.resxCulture].PortfolioCondition_Text || langMap.en.PortfolioCondition_Text;
    },
    get PortfolioCreator_Text() {
        return langMap[ep.resxCulture].PortfolioCreator_Text || langMap.en.PortfolioCreator_Text;
    },
    get PortfolioCreatorCondition_Text() {
        return langMap[ep.resxCulture].PortfolioCreatorCondition_Text || langMap.en.PortfolioCreatorCondition_Text;
    },
    get PortfolioManager_Text() {
        return langMap[ep.resxCulture].PortfolioManager_Text || langMap.en.PortfolioManager_Text;
    },
    get PortfolioManagerCondition_Text() {
        return langMap[ep.resxCulture].PortfolioManagerCondition_Text || langMap.en.PortfolioManagerCondition_Text;
    },
    get PreviousMonth() {
        return langMap[ep.resxCulture].PreviousMonth || langMap.en.PreviousMonth;
    },
    get PreviousWeek() {
        return langMap[ep.resxCulture].PreviousWeek || langMap.en.PreviousWeek;
    },
    get PreviousYear() {
        return langMap[ep.resxCulture].PreviousYear || langMap.en.PreviousYear;
    },
    get PriorityCondition_Text() {
        return langMap[ep.resxCulture].PriorityCondition_Text || langMap.en.PriorityCondition_Text;
    },
    get Progress_Filters_Group() {
        return langMap[ep.resxCulture].Progress_Filters_Group || langMap.en.Progress_Filters_Group;
    },
    get ProgressCondition_Entity() {
        return langMap[ep.resxCulture].ProgressCondition_Entity || langMap.en.ProgressCondition_Entity;
    },
    get ProgressCondition_Text() {
        return langMap[ep.resxCulture].ProgressCondition_Text || langMap.en.ProgressCondition_Text;
    },
    get Project_Text() {
        return langMap[ep.resxCulture].Project_Text || langMap.en.Project_Text;
    },
    get ProjectActualBilling() {
        return langMap[ep.resxCulture].ProjectActualBilling || langMap.en.ProjectActualBilling;
    },
    get ProjectActualCompletionDateCondition_Text() {
        return langMap[ep.resxCulture].ProjectActualCompletionDateCondition_Text || langMap.en.ProjectActualCompletionDateCondition_Text;
    },
    get ProjectActualCost() {
        return langMap[ep.resxCulture].ProjectActualCost || langMap.en.ProjectActualCost;
    },
    get ProjectActualGreaterThanEstimated_Text() {
        return langMap[ep.resxCulture].ProjectActualGreaterThanEstimated_Text || langMap.en.ProjectActualGreaterThanEstimated_Text;
    },
    get ProjectActualHours() {
        return langMap[ep.resxCulture].ProjectActualHours || langMap.en.ProjectActualHours;
    },
    get ProjectActualLaborBilling() {
        return langMap[ep.resxCulture].ProjectActualLaborBilling || langMap.en.ProjectActualLaborBilling;
    },
    get ProjectActualLaborCost() {
        return langMap[ep.resxCulture].ProjectActualLaborCost || langMap.en.ProjectActualLaborCost;
    },
    get ProjectBillableHours() {
        return langMap[ep.resxCulture].ProjectBillableHours || langMap.en.ProjectBillableHours;
    },
    get ProjectBilled() {
        return langMap[ep.resxCulture].ProjectBilled || langMap.en.ProjectBilled;
    },
    get ProjectBilledLabor() {
        return langMap[ep.resxCulture].ProjectBilledLabor || langMap.en.ProjectBilledLabor;
    },
    get ProjectBilledPercentage() {
        return langMap[ep.resxCulture].ProjectBilledPercentage || langMap.en.ProjectBilledPercentage;
    },
    get ProjectBudgetVariance() {
        return langMap[ep.resxCulture].ProjectBudgetVariance || langMap.en.ProjectBudgetVariance;
    },
    get ProjectCondition_EmptyText() {
        return langMap[ep.resxCulture].ProjectCondition_EmptyText || langMap.en.ProjectCondition_EmptyText;
    },
    get ProjectCondition_Entity() {
        return langMap[ep.resxCulture].ProjectCondition_Entity || langMap.en.ProjectCondition_Entity;
    },
    get ProjectCondition_Text() {
        return langMap[ep.resxCulture].ProjectCondition_Text || langMap.en.ProjectCondition_Text;
    },
    get ProjectCostExceedBudget_Text() {
        return langMap[ep.resxCulture].ProjectCostExceedBudget_Text || langMap.en.ProjectCostExceedBudget_Text;
    },
    get ProjectCreationDateCondition_Text() {
        return langMap[ep.resxCulture].ProjectCreationDateCondition_Text || langMap.en.ProjectCreationDateCondition_Text;
    },
    get ProjectCreator_Text() {
        return langMap[ep.resxCulture].ProjectCreator_Text || langMap.en.ProjectCreator_Text;
    },
    get ProjectCreatorCondition_Text() {
        return langMap[ep.resxCulture].ProjectCreatorCondition_Text || langMap.en.ProjectCreatorCondition_Text;
    },
    get ProjectCustomFieldCondition_Text() {
        return langMap[ep.resxCulture].ProjectCustomFieldCondition_Text || langMap.en.ProjectCustomFieldCondition_Text;
    },
    get ProjectDuration() {
        return langMap[ep.resxCulture].ProjectDuration || langMap.en.ProjectDuration;
    },
    get ProjectEACBillableExpenses() {
        return langMap[ep.resxCulture].ProjectEACBillableExpenses || langMap.en.ProjectEACBillableExpenses;
    },
    get ProjectEACBilling() {
        return langMap[ep.resxCulture].ProjectEACBilling || langMap.en.ProjectEACBilling;
    },
    get ProjectEACCost() {
        return langMap[ep.resxCulture].ProjectEACCost || langMap.en.ProjectEACCost;
    },
    get ProjectEACExpenses() {
        return langMap[ep.resxCulture].ProjectEACExpenses || langMap.en.ProjectEACExpenses;
    },
    get ProjectEACLaborBilling() {
        return langMap[ep.resxCulture].ProjectEACLaborBilling || langMap.en.ProjectEACLaborBilling;
    },
    get ProjectEACLaborCost() {
        return langMap[ep.resxCulture].ProjectEACLaborCost || langMap.en.ProjectEACLaborCost;
    },
    get ProjectEACNonBillableExpenses() {
        return langMap[ep.resxCulture].ProjectEACNonBillableExpenses || langMap.en.ProjectEACNonBillableExpenses;
    },
    get ProjectEndDateCondition_Text() {
        return langMap[ep.resxCulture].ProjectEndDateCondition_Text || langMap.en.ProjectEndDateCondition_Text;
    },
    get ProjectEstimatedExpensesAmount() {
        return langMap[ep.resxCulture].ProjectEstimatedExpensesAmount || langMap.en.ProjectEstimatedExpensesAmount;
    },
    get ProjectEstimatedExpensesBillableAmount() {
        return langMap[ep.resxCulture].ProjectEstimatedExpensesBillableAmount || langMap.en.ProjectEstimatedExpensesBillableAmount;
    },
    get ProjectEstimatedExpensesNonBillableAmount() {
        return langMap[ep.resxCulture].ProjectEstimatedExpensesNonBillableAmount || langMap.en.ProjectEstimatedExpensesNonBillableAmount;
    },
    get ProjectEstimatedHours() {
        return langMap[ep.resxCulture].ProjectEstimatedHours || langMap.en.ProjectEstimatedHours;
    },
    get ProjectETCBilling() {
        return langMap[ep.resxCulture].ProjectETCBilling || langMap.en.ProjectETCBilling;
    },
    get ProjectETCCost() {
        return langMap[ep.resxCulture].ProjectETCCost || langMap.en.ProjectETCCost;
    },
    get ProjectETCLaborBilling() {
        return langMap[ep.resxCulture].ProjectETCLaborBilling || langMap.en.ProjectETCLaborBilling;
    },
    get ProjectETCLaborCost() {
        return langMap[ep.resxCulture].ProjectETCLaborCost || langMap.en.ProjectETCLaborCost;
    },
    get ProjectExpectedProfit() {
        return langMap[ep.resxCulture].ProjectExpectedProfit || langMap.en.ProjectExpectedProfit;
    },
    get ProjectExpectedProfitPercentage() {
        return langMap[ep.resxCulture].ProjectExpectedProfitPercentage || langMap.en.ProjectExpectedProfitPercentage;
    },
    get ProjectExpensesAmount() {
        return langMap[ep.resxCulture].ProjectExpensesAmount || langMap.en.ProjectExpensesAmount;
    },
    get ProjectExpensesBillableAmount() {
        return langMap[ep.resxCulture].ProjectExpensesBillableAmount || langMap.en.ProjectExpensesBillableAmount;
    },
    get ProjectExpensesBilledAmount() {
        return langMap[ep.resxCulture].ProjectExpensesBilledAmount || langMap.en.ProjectExpensesBilledAmount;
    },
    get ProjectExpensesNonBillableAmount() {
        return langMap[ep.resxCulture].ProjectExpensesNonBillableAmount || langMap.en.ProjectExpensesNonBillableAmount;
    },
    get ProjectHealthCondition_Text() {
        return langMap[ep.resxCulture].ProjectHealthCondition_Text || langMap.en.ProjectHealthCondition_Text;
    },
    get ProjectHealthTypes() {
        return langMap[ep.resxCulture].ProjectHealthTypes || langMap.en.ProjectHealthTypes;
    },
    get ProjectManager_Text() {
        return langMap[ep.resxCulture].ProjectManager_Text || langMap.en.ProjectManager_Text;
    },
    get ProjectManagerCondition_Text() {
        return langMap[ep.resxCulture].ProjectManagerCondition_Text || langMap.en.ProjectManagerCondition_Text;
    },
    get ProjectMemberCondition_Text() {
        return langMap[ep.resxCulture].ProjectMemberCondition_Text || langMap.en.ProjectMemberCondition_Text;
    },
    get ProjectNonBillableHours() {
        return langMap[ep.resxCulture].ProjectNonBillableHours || langMap.en.ProjectNonBillableHours;
    },
    get ProjectPriorityCondition_Text() {
        return langMap[ep.resxCulture].ProjectPriorityCondition_Text || langMap.en.ProjectPriorityCondition_Text;
    },
    get ProjectPriorityCondition_Text_Template() {
        return langMap[ep.resxCulture].ProjectPriorityCondition_Text_Template || langMap.en.ProjectPriorityCondition_Text_Template;
    },
    get ProjectProcessCondition_Text() {
        return langMap[ep.resxCulture].ProjectProcessCondition_Text || langMap.en.ProjectProcessCondition_Text;
    },
    get ProjectProfit() {
        return langMap[ep.resxCulture].ProjectProfit || langMap.en.ProjectProfit;
    },
    get ProjectProfit_Text() {
        return langMap[ep.resxCulture].ProjectProfit_Text || langMap.en.ProjectProfit_Text;
    },
    get ProjectProfitPercentage() {
        return langMap[ep.resxCulture].ProjectProfitPercentage || langMap.en.ProjectProfitPercentage;
    },
    get ProjectProgress_Text() {
        return langMap[ep.resxCulture].ProjectProgress_Text || langMap.en.ProjectProgress_Text;
    },
    get ProjectsAndTasksList_Title() {
        return langMap[ep.resxCulture].ProjectsAndTasksList_Title || langMap.en.ProjectsAndTasksList_Title;
    },
    get ProjectsCustomersAndMore_Filters_Group() {
        return langMap[ep.resxCulture].ProjectsCustomersAndMore_Filters_Group || langMap.en.ProjectsCustomersAndMore_Filters_Group;
    },
    get ProjectStartDateCondition_Text() {
        return langMap[ep.resxCulture].ProjectStartDateCondition_Text || langMap.en.ProjectStartDateCondition_Text;
    },
    get ProjectStatusCondition_Text() {
        return langMap[ep.resxCulture].ProjectStatusCondition_Text || langMap.en.ProjectStatusCondition_Text;
    },
    get ProjectTotalBudget() {
        return langMap[ep.resxCulture].ProjectTotalBudget || langMap.en.ProjectTotalBudget;
    },
    get QuickFilterWatermark() {
        return langMap[ep.resxCulture].QuickFilterWatermark || langMap.en.QuickFilterWatermark;
    },
    get range_condition_text() {
        return langMap[ep.resxCulture].range_condition_text || langMap.en.range_condition_text;
    },
    get Request_Text() {
        return langMap[ep.resxCulture].Request_Text || langMap.en.Request_Text;
    },
    get resource_types_condition_text() {
        return langMap[ep.resxCulture].resource_types_condition_text || langMap.en.resource_types_condition_text;
    },
    get resource_types_planning_condition_text() {
        return langMap[ep.resxCulture].resource_types_planning_condition_text || langMap.en.resource_types_planning_condition_text;
    },
    get resource_types_unnamed_label() {
        return langMap[ep.resxCulture].resource_types_unnamed_label || langMap.en.resource_types_unnamed_label;
    },
    get resource_types_user_label() {
        return langMap[ep.resxCulture].resource_types_user_label || langMap.en.resource_types_user_label;
    },
    get ResourceRequestApprover_Text() {
        return langMap[ep.resxCulture].ResourceRequestApprover_Text || langMap.en.ResourceRequestApprover_Text;
    },
    get ResourceRequestCreator_Text() {
        return langMap[ep.resxCulture].ResourceRequestCreator_Text || langMap.en.ResourceRequestCreator_Text;
    },
    get ResourceRequestStatuses_Approved() {
        return langMap[ep.resxCulture].ResourceRequestStatuses_Approved || langMap.en.ResourceRequestStatuses_Approved;
    },
    get ResourceRequestStatuses_Rejected() {
        return langMap[ep.resxCulture].ResourceRequestStatuses_Rejected || langMap.en.ResourceRequestStatuses_Rejected;
    },
    get ResourceRequestStatuses_WaitingForApproval() {
        return langMap[ep.resxCulture].ResourceRequestStatuses_WaitingForApproval || langMap.en.ResourceRequestStatuses_WaitingForApproval;
    },
    get ResourceRequestStatuses_WithoutRequest() {
        return langMap[ep.resxCulture].ResourceRequestStatuses_WithoutRequest || langMap.en.ResourceRequestStatuses_WithoutRequest;
    },
    get ResourceRequestStatusFilter_Text() {
        return langMap[ep.resxCulture].ResourceRequestStatusFilter_Text || langMap.en.ResourceRequestStatusFilter_Text;
    },
    get resources_filters_group() {
        return langMap[ep.resxCulture].resources_filters_group || langMap.en.resources_filters_group;
    },
    get resources_requests_filters_group() {
        return langMap[ep.resxCulture].resources_requests_filters_group || langMap.en.resources_requests_filters_group;
    },
    get ResourcesAndConstraints_Filters_Group() {
        return langMap[ep.resxCulture].ResourcesAndConstraints_Filters_Group || langMap.en.ResourcesAndConstraints_Filters_Group;
    },
    get roles_condition_text() {
        return langMap[ep.resxCulture].roles_condition_text || langMap.en.roles_condition_text;
    },
    get RollBack_Text() {
        return langMap[ep.resxCulture].RollBack_Text || langMap.en.RollBack_Text;
    },
    get SaveFilters_Title() {
        return langMap[ep.resxCulture].SaveFilters_Title || langMap.en.SaveFilters_Title;
    },
    get set_filters() {
        return langMap[ep.resxCulture].set_filters || langMap.en.set_filters;
    },
    get set_filters_part2() {
        return langMap[ep.resxCulture].set_filters_part2 || langMap.en.set_filters_part2;
    },
    get skills_condition_text() {
        return langMap[ep.resxCulture].skills_condition_text || langMap.en.skills_condition_text;
    },
    get StartDate_Text() {
        return langMap[ep.resxCulture].StartDate_Text || langMap.en.StartDate_Text;
    },
    get Statuses_Filters_Group() {
        return langMap[ep.resxCulture].Statuses_Filters_Group || langMap.en.Statuses_Filters_Group;
    },
    get StatusesCountFormat() {
        return langMap[ep.resxCulture].StatusesCountFormat || langMap.en.StatusesCountFormat;
    },
    get Task_Text() {
        return langMap[ep.resxCulture].Task_Text || langMap.en.Task_Text;
    },
    get TaskCondition_Entity() {
        return langMap[ep.resxCulture].TaskCondition_Entity || langMap.en.TaskCondition_Entity;
    },
    get TaskCondition_Text() {
        return langMap[ep.resxCulture].TaskCondition_Text || langMap.en.TaskCondition_Text;
    },
    get TaskCostExceedBudget_Text() {
        return langMap[ep.resxCulture].TaskCostExceedBudget_Text || langMap.en.TaskCostExceedBudget_Text;
    },
    get TaskPriorityCondition_Entity() {
        return langMap[ep.resxCulture].TaskPriorityCondition_Entity || langMap.en.TaskPriorityCondition_Entity;
    },
    get TaskPriorityCondition_Text() {
        return langMap[ep.resxCulture].TaskPriorityCondition_Text || langMap.en.TaskPriorityCondition_Text;
    },
    get TaskPriorityCondition_Text_Template() {
        return langMap[ep.resxCulture].TaskPriorityCondition_Text_Template || langMap.en.TaskPriorityCondition_Text_Template;
    },
    get TasksAssignedToMilestone_Text() {
        return langMap[ep.resxCulture].TasksAssignedToMilestone_Text || langMap.en.TasksAssignedToMilestone_Text;
    },
    get teams_condition_text() {
        return langMap[ep.resxCulture].teams_condition_text || langMap.en.teams_condition_text;
    },
    get TemplateCondition_Text() {
        return langMap[ep.resxCulture].TemplateCondition_Text || langMap.en.TemplateCondition_Text;
    },
    get TemplateStatus_Text() {
        return langMap[ep.resxCulture].TemplateStatus_Text || langMap.en.TemplateStatus_Text;
    },
    get ThisMonth() {
        return langMap[ep.resxCulture].ThisMonth || langMap.en.ThisMonth;
    },
    get ThisWeek() {
        return langMap[ep.resxCulture].ThisWeek || langMap.en.ThisWeek;
    },
    get ThisYear() {
        return langMap[ep.resxCulture].ThisYear || langMap.en.ThisYear;
    },
    get To_Text() {
        return langMap[ep.resxCulture].To_Text || langMap.en.To_Text;
    },
    get Today() {
        return langMap[ep.resxCulture].Today || langMap.en.Today;
    },
    get TypesCondition_Text() {
        return langMap[ep.resxCulture].TypesCondition_Text || langMap.en.TypesCondition_Text;
    },
    get UnpinTooltip_Text() {
        return langMap[ep.resxCulture].UnpinTooltip_Text || langMap.en.UnpinTooltip_Text;
    },
    get users_condition_text() {
        return langMap[ep.resxCulture].users_condition_text || langMap.en.users_condition_text;
    },
    get Yesterday() {
        return langMap[ep.resxCulture].Yesterday || langMap.en.Yesterday;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.filters = filtersResx;
